import { render, staticRenderFns } from "./PlayerNewBookingRequestCard.vue?vue&type=template&id=63cf3e62&"
import script from "./PlayerNewBookingRequestCard.vue?vue&type=script&lang=js&"
export * from "./PlayerNewBookingRequestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports